export var ChfarAirOrchestratorEvent;
(function (ChfarAirOrchestratorEvent) {
    ChfarAirOrchestratorEvent["VIEW_CHFAR"] = "view_chfar";
    ChfarAirOrchestratorEvent["SKIP_CHFAR"] = "skip_chfar";
    ChfarAirOrchestratorEvent["CHOOSE_CHFAR"] = "choose_chfar";
    ChfarAirOrchestratorEvent["CHFAR_EXERCISE_QUOTE"] = "chfar_exercise_quote";
    ChfarAirOrchestratorEvent["CHFAR_EXERCISE_QUOTE_FAIL"] = "chfar_exercise_quote_fail";
    ChfarAirOrchestratorEvent["CHFAR_EXERCISE_COMPLETE"] = "chfar_exercise_complete";
    ChfarAirOrchestratorEvent["CHFAR_EXERCISE_COMPLETE_FAIL"] = "chfar_exercise_complete_fail";
})(ChfarAirOrchestratorEvent || (ChfarAirOrchestratorEvent = {}));
//# sourceMappingURL=events.js.map